(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}__webpack_unused_export__=l;exports.jsx=q;__webpack_unused_export__=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 81301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","i":"src-components-Icon-styles_i","smallIcon":"src-components-Icon-styles_smallIcon","disabled":"src-components-Icon-styles_disabled","greyIcon":"src-components-Icon-styles_greyIcon"});

/***/ }),

/***/ 87083:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_BaseIcon)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(69122);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/Icon/styles.scss
var styles = __webpack_require__(81301);
;// ./src/components/Icon/BaseIcon/BaseIcon.tsx
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};




function BaseIcon(_a) {
    var { icon, src, className, isDisabled = false, onClick = () => null, onMouseEnter = () => null, onMouseLeave = () => null, isSmall = false, isGrey = false, style } = _a, restProps = __rest(_a, ["icon", "src", "className", "isDisabled", "onClick", "onMouseEnter", "onMouseLeave", "isSmall", "isGrey", "style"]);
    const [iconHtml, setIconHtml] = (0,external_react_.useState)(null);
    const isMounted = (0,external_react_.useRef)(false);
    (0,external_react_.useEffect)(() => {
        const controller = new AbortController();
        isMounted.current = true;
        getIconHtml(controller);
        return () => {
            isMounted.current = false;
            controller === null || controller === void 0 ? void 0 : controller.abort();
        };
    }, [icon, src]);
    const getIconHtml = (controller) => __awaiter(this, void 0, void 0, function* () {
        if (src) {
            let iconResponse = yield fetch(src, {
                signal: controller.signal,
            });
            // @ts-ignore
            setIconHtml(yield iconResponse.text());
            // @ts-ignore
            controller = null;
            return;
        }
        let iconHtml = null;
        if (icon) {
            iconHtml = icon;
        }
        // @ts-ignore
        isMounted.current && setIconHtml(iconHtml);
    });
    return ((0,jsx_runtime.jsx)("i", { "data-test": restProps['data-test'], className: classnames_default()(styles/* default */.A.i, className, {
            [styles/* default */.A.disabled]: isDisabled,
            [styles/* default */.A.smallIcon]: isSmall,
            [styles/* default */.A.greyIcon]: isGrey,
        }), 
        // @ts-ignore
        dangerouslySetInnerHTML: { __html: iconHtml }, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style }));
}
/* harmony default export */ const BaseIcon_BaseIcon = (BaseIcon);

;// ./src/components/Icon/BaseIcon/index.ts

/* harmony default export */ const Icon_BaseIcon = (BaseIcon_BaseIcon);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Icon_IconUnpin)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: ./src/components/Icon/BaseIcon/index.ts + 1 modules
var BaseIcon = __webpack_require__(87083);
;// ./src/components/Icon/IconUnpin/unpin.inline.svg?raw
/* harmony default export */ const unpin_inlineraw = ("<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M15.4993 6.75966L11.94 8.9272L7.24977 3.79103L9.2483 0.501356C9.31849 0.380018 9.4131 0.274794 9.52638 0.192274C9.63954 0.109816 9.76881 0.0519543 9.90565 0.0224744C10.0425 -0.00700563 10.184 -0.00749391 10.3211 0.0210705C10.4003 0.0376111 10.4771 0.063612 10.5498 0.0984021C10.6028 0.123732 10.6536 0.153822 10.7016 0.188307L15.812 5.30476C15.8552 5.36506 15.8915 5.42976 15.9203 5.49769C15.9459 5.55812 15.9656 5.62105 15.979 5.68562C16.0075 5.82283 16.007 5.96455 15.9776 6.10158C15.9481 6.2386 15.8904 6.36793 15.808 6.48128C15.7256 6.59462 15.6204 6.68947 15.4993 6.75966Z\"/>\n  <path d=\"M14.5 14.6968L13.0073 16L0.5 2.30318L1.99274 1L14.5 14.6968Z\"/>\n  <path d=\"M0.176281 14.7726L4.38197 9.84364L6.16298 11.6217L1.23475 15.8324C1.09645 15.9446 0.922741 16.0039 0.744763 15.9998C0.675427 15.9993 0.606945 15.9891 0.541027 15.9699C0.471447 15.9496 0.404919 15.9193 0.343396 15.8795C0.303601 15.8538 0.266491 15.8244 0.232434 15.7919C0.164318 15.7268 0.108654 15.6491 0.0688595 15.5626C0.00928917 15.4331 -0.0123173 15.2892 0.00672569 15.1478C0.0257687 15.0064 0.0844845 14.8734 0.176281 14.7642V14.7726Z\"/>\n</svg>\n");
;// ./src/components/Icon/IconUnpin/IconUnpin.tsx



const IconUnpin = (props) => ((0,jsx_runtime.jsx)(BaseIcon["default"], Object.assign({ icon: unpin_inlineraw }, props)));
/* harmony default export */ const IconUnpin_IconUnpin = (IconUnpin);

;// ./src/components/Icon/IconUnpin/index.ts

/* harmony default export */ const Icon_IconUnpin = (IconUnpin_IconUnpin);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map